export const AVATAR_SIZE_MAP = {
    "2xs": 3,
    xs: 4,
    sm: 5,
    md: 6,
    lg: 7,
    xl: 8,
    "2xl": 10,
} as const;

export type IAvatarSize = keyof typeof AVATAR_SIZE_MAP;

export const AVATAR_PIXEL_SIZE_UNIT = 8;
